<template>
  <DatePicker
    v-model="internalValue"
    v-bind="$attrs"
    :format="format"
    :title-format="format"
    :value-type="valueType"
    :time-title-format="timeTitleFormat"
    :lang="lang"
    :class="{ 'datepicker--error': error }"
    class="datepicker"
    popup-class="datepicker__popup"
  />
</template>

<script>
import DatePicker from 'vue2-datepicker'

export default {
  name: 'AppDatePicker',
  components: {DatePicker},
  inheritAttrs: false,
  props: {
    value: null,
    error: {
      type: Boolean,
      default: false
    },
    format: {
      type: String,
      default: 'DD MMM YYYY'
    },
    valueType: {
      type: String,
      default: 'YYYY-MM-DD'
    },
    timeTitleFormat: {
      type: String,
      default: 'DD MMM YYYY'
    }
  },
  data() {
    return {
      internalValue: this.value,
      lang: {
        formatLocale: {
          months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
          monthsShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
          weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
          weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          weekdaysMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
          firstDayOfWeek: 1
        }
      }
    }
  },
  watch: {
    value(newValue) {
      if (newValue !== this.internalValue) {
        this.internalValue = newValue
      }
    },
    internalValue(newValue) {
      if (newValue !== this.value) this.$emit('input', newValue)
    }
  },
}
</script>

<style lang="sass">
$default-color: $color-text-base
$primary-color: $color-theme

@import "vue2-datepicker/scss/index"

.datepicker
  width: 100%

  .mx-input
    height: 38px
    padding-left: 12px
    box-shadow: none
    border-radius: 6px
    border-color: $color-border
    color: $color-text-base
    font-size: 13px
    transition: border-color 0.3s

    &:focus
      border-color: #aaa

  &[readonly]
    pointer-events: none

    .mx-input
      padding: 6px 12px
      border-color: #ff9416

    .mx-icon-calendar
      display: none

.datepicker--220
  width: 220px

.datepicker--300
  width: 300px

.datepicker--center
  .mx-input
    text-align: center

.datepicker--error
  .mx-input
    border-color: $color-error

.datepicker--filter
  width: 140px

.datepicker__popup
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1)
  font-size: 12px
  font-family: $font-family-base

  .mx-calendar
    width: 220px
    padding: 0

  .mx-calendar-header
    height: 38px
    padding: 2px 12px 0
    background-color: #f7f7f7

  .mx-calendar-content
    height: 200px
    padding: 0 6px 4px

    .mx-date-row
      .cell
        &.active
          border-radius: 50%

        &:hover
          border-radius: 50%
          background-color: #efefef

    .mx-table-date td, .mx-table-date th
      height: 28px

  .mx-time-content
    height: 200px

.datepicker--table
  max-width: 110px

  .mx-input
    cursor: pointer
    height: auto
    border: none
    padding: 0
    font-size: 14px
    text-align: center
    background-color: transparent

  .mx-icon-calendar
    display: none

.datepicker--table-expired
  .mx-input
    padding: 5px 10px 4px
    border-radius: 20px
    color: #fff
    background-color: #e85c20
    font-weight: 600
</style>
